export const fakeResp = {
	data: {
		pagesPaginated: {
			total: 2,
			page: 1,
			limit: 12,
			totalPages: 1,
			data: [
				{
					id: '15e06f4d-62c0-42fd-b919-6a5aebb6d2af',
					name: 'Nombre teste1',
					slug: 'nombre-teste1',
					vtex_query: 'queryteste1',
					show_tab_bar: true,
					header_type: 'Tipo de encabezado text',
					__typename: 'Page'
				},
				{
					id: '3d54b3a8-3e61-4b34-b8e4-fd139681ed5a',
					name: 'Nombre* teste2 ',
					slug: 'nombre*-teste2',
					vtex_query: 'Query Vtex teste',
					show_tab_bar: null,
					header_type: 'tipo teste',
					__typename: 'Page'
				}
			],
			__typename: 'PagePaginated'
		}
	}
};
